(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/reset-to-system.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/reset-to-system.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const engine = svs.components.tipsen.engine;
const selectSystem = engine.actions.selectSystem;
const selectSystemType = engine.selectors.couponSelectors.selectSystemType;
const selectSystemTypes = engine.selectors.engineSelectors.selectSystemTypes;
const SYSTEM_MSYS = engine.constants.systems.SYSTEM_MSYS;
const useCouponId = svs.components.tipsen.couponId.useCouponId;
const ResetToSystem = () => {
  const couponId = useCouponId();
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const systemTypes = useSelector(selectSystemTypes);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(selectSystem({
      systemTypes,
      couponId,
      system: systemTypes.indexOf(SYSTEM_MSYS)
    }));
  }, [dispatch, systemType, couponId, systemTypes]);
  return null;
};
setGlobal('svs.components.tipsen.routePlaySpela.ResetToSystem', ResetToSystem);

 })(window);